import { birthdayDPicker, ajax_api } from '../Globals';
import { ordinal_suffix_of, getOptions } from '../Components/ReactGlobals';
import SessionAdd from '../Components/MainComponents/SessionAdd';
import DynamicAdd from '../Components/ReactComponents/DynamicAdd';

export function routeTitles(key) {

    var routes = {
        "/": {
            title: "Legislative Tracking System",
        },
        "/dashboard": {
            title: "Legislative Tracking System",
        },
        "/documents": {
            title: "Documents",
            subtitle: "Manage incoming/outgoing documents",
        },
        "/agenda": {
            title: "Agenda",
            subtitle: "SP Session list, details, and agenda",
        },
        "/legislations": {
            title: "Legislations",
            subtitle: "List of SP Resolutions/Items, and details",
        },
        "/communications": {
            title: "Communications",
            subtitle: "Document/SP Item data transmission",
        },
        "/reports": {
            title: "Reports",
            subtitle: "Generate reports",
        },
        "/item-properties/types": {
            title: "SP Item Types",
            subtitle: "Data management for SP Item Types",
            btns: [
                {
                    access: "25",
                    name: "Add New",
                    modal: {
                        Title: "Add New Item Type",
                        Component: DynamicAdd,
                        ModalProps: {
                            url: `${ajax_api}item-props/types/add`
                        }
                    }
                }
            ]
        },
        "/admin-panel/ftp-locations": {
            title: "FTP Locations",
            subtitle: "Data management for FTP Locations",
            btns: [
                {
                    name: "Add New",
                    access: "93",
                    modal: {
                        Title: "Add New FTP Location",
                        Component: DynamicAdd,
                        ModalProps: {
                            url: `${ajax_api}ftp/ftp-locations/add`,
                            input: [
                                { label: "FTP Label/Name", name: "label" },
                                { label: "Host", name: "host", props: { required: true } },
                                { label: "Port", name: "MiddleName", props: { placeholder: "leave blank for default port 21" } },
                                { label: "Username", name: "username", props: { required: true } },
                                { label: "Password", name: "password", props: { required: true } },
                            ]
                        }
                    }
                }
            ]
        },
        "/admin-panel/files-relink": {
            title: "Files Relink",
            subtitle: "Relink documents, attachments, and scanned files to ordinances!"
        },
        "/item-properties/sessions": {
            title: "SP Sessions",
            subtitle: "Data management for SP Sessions",
            btns: [
                {
                    access: "25",
                    name: "Add New",
                    modal: {
                        Title: "Add New Session",
                        Component: SessionAdd,
                        ModalProps: {
                            url: `${ajax_api}item-props/sessions/add`
                        }
                    }
                }
            ]
        },
        "/item-properties/committees": {
            title: "SP Committees",
            subtitle: "Data management for SP Committees",
            btns: [
                {
                    access: "33",
                    name: "Add New",
                    modal: {
                        Title: "Add New Committee",
                        Component: DynamicAdd,
                        ModalProps: {
                            url: `${ajax_api}item-props/committees/add`
                        }
                    }
                }
            ]
        },
        "/item-properties/categories": {
            title: "SP Item Categories",
            subtitle: "Data management for SP Categories / Classifications",
            btns: [
                {
                    access: "17",
                    name: "Add New",
                    modal: {
                        Title: "Add New Category",
                        Component: DynamicAdd,
                        ModalProps: {
                            url: `${ajax_api}item-props/categories/add`
                        }
                    }
                }
            ]
        },
        "/item-properties/status": {
            title: "Tracking Status",
            subtitle: "Data management for SP Item Tracking Status",
            btns: [
                {
                    access: "83",
                    name: "Add New",
                    modal: {
                        Title: "Add New Tracking Status",
                        Component: DynamicAdd,
                        ModalProps: {
                            url: `${ajax_api}item-props/tracking-status/add`
                        }
                    }
                }
            ]
        },

        "/officials/list": {
            title: "Officials List",
            subtitle: "Data management for SP Officials",
            btns: [
                {
                    access: "52",
                    name: "Add New",
                    modal: {
                        Title: "Add New Official",
                        Component: DynamicAdd,
                        ModalProps: {
                            url: `${ajax_api}officials/save`,
                            input: [
                                { label: "Official Number", name: "OfficialNo" },
                                { label: "First Name", name: "FirstName", props: { required: true } },
                                { label: "Middle Name", name: "MiddleName" },
                                { label: "Last Name", name: "LastName", props: { required: true } },
                                { label: "Suffix", name: "Suffix" },
                                {
                                    label: "Birth Date",
                                    name: "BirthDate",
                                    type: "date",
                                    controlProps: birthdayDPicker
                                },
                                { label: "Comments", type: "textarea", name: "Comments" },
                            ]
                        }
                    }
                }
            ]
        },
        "/officials/types": {
            title: "Officials Types",
            subtitle: "Data management for Official Types",
            btns: [
                {
                    access: "30",
                    name: "Add New",
                    modal: {
                        Title: "Add New Official Type",
                        Component: DynamicAdd,
                        ModalProps: {
                            url: `${ajax_api}official-props/official-types/add`
                        }
                    }
                }
            ]
        },
        "/officials/council-statuses": {
            title: "Council Member Status",
            subtitle: "Data management for Council Member Statuses for Officials",
            btns: [
                {
                    access: "30",
                    name: "Add New",
                    modal: {
                        Title: "Add New Council Status",
                        Component: DynamicAdd,
                        ModalProps: {
                            url: `${ajax_api}official-props/council-status/add`
                        }
                    }
                }
            ]
        },
        "/officials/committee-types": {
            title: "Official Committee Types",
            subtitle: "Data management for Committee Types for Officials",
            btns: [
                {
                    access: "49",
                    name: "Add New",
                    modal: {
                        Title: "Add New Committee Type",
                        Component: DynamicAdd,
                        ModalProps: {
                            url: `${ajax_api}official-props/committee-types/add`
                        }
                    }
                }
            ]
        },


        "/councils/list": {
            title: "Councils",
            subtitle: "Data management for SP Councils",
            btns: [
                {
                    access: "37",
                    name: "Add New",
                    modal: {
                        Title: "Add New Council",
                        Component: DynamicAdd,
                        ModalProps: {
                            url: `${ajax_api}councils/add`,
                            input: [
                                {
                                    label: "Council Number", name: "CouncilNo", type: "select",
                                    options: _ => new Promise(function (resolve, reject) {
                                        return resolve(Array.from({ length: 30 }, (_, i) => { return { value: i + 1, label: ordinal_suffix_of(i + 1) + " SP Council" } }));
                                    })
                                },
                                { label: "Period From", name: "PeriodFrom", type: "number", props: { required: true } },
                                { label: "Period To", name: "PeriodTo", type: "number", props: { required: true } },
                                { label: "Add all committees to council?", name: "AddAll", type: "checkbox" },
                            ]
                        }
                    }
                }
            ]
        },
        "/councils/officials": {
            title: "Council Members",
            subtitle: "Data management for SP Council Members",
        },
        "/councils/committees": {
            title: "Council Committees and Members",
            subtitle: "Data management for SP Council Committees and its members",
        },


        "/admin-panel/users": {
            title: "User Accounts",
            subtitle: "User Account List and Management",
            btns: [
                {
                    access: "12",
                    name: "Add New",
                    modal: {
                        Title: "Add New User Account",
                        Component: DynamicAdd,
                        ModalProps: {
                            url: `${ajax_api}users/add-user`,
                            autoFills:
                                [{
                                    From: "FullName",
                                    To: "LoginId",
                                    Func: d => {
                                        if (d == null) return "";
                                        var splitted = d.split(' ');
                                        return splitted[0]?.toLowerCase() + (splitted.length - 1 == 0 ? "" : "." + splitted[splitted.length - 1]?.toLowerCase());
                                    }
                                }],
                            input: [
                                {
                                    label: "Role", name: "UserRoleId", type: "select",
                                    options: _ => getOptions(`${ajax_api}users/get-roles`),
                                    props: {
                                        required: true
                                    }
                                },
                                { label: "Full Name", name: "FullName", props: { required: true } },
                                {
                                    label: "Login ID", name: "LoginId",
                                    props: { required: true }
                                },
                                {
                                    label: "Temporary Password", name: "Password", type: "password", props: {
                                        required: true,
                                        minLength: {
                                            value: 8,
                                            message: "Minimum of 8 characters for password"
                                        },
                                        pattern: {
                                            value: /^(?=.*[a-zA-Z].*)(?=.*\d+.*)(?=.*[!@#\$%\^\&*\)\(+=._-].*).*$/g,
                                            message: "Password should have a special character, a number, and a letter"
                                        }
                                    }
                                }
                            ]
                        }
                    }
                }
            ]
        },
        "/admin-panel/roles": {
            title: "Roles",
            subtitle: "Manage user account roles",
            btns: [
                {
                    access: "4",
                    name: "Add New",
                    modal: {
                        Title: "Add New Role",
                        Component: DynamicAdd,
                        ModalProps: {
                            url: `${ajax_api}users/add-role`
                        }
                    }
                }
            ]
        },
        "/admin-panel/activities": {
            title: "Role Activities",
            subtitle: "Manage activities connected to user roles",
        },
        "/admin-panel/logs": {
            title: "Activity Logs",
            subtitle: "Monitor user activity",
        },
        "/admin-panel/db-sync": {
            title: "Database Sync"
        },

        "/sp-items": {
            title: "SP Item List",
            subtitle: "SP Resolutions/Ordinances/Items",
            btns: [
                {
                    access: "56",
                    name: "Add New",
                    link: "/sp-items/create"
                }
            ]
        },
        "/sp-items/view/:Id": {
            title: "View SP Item",
            subtitle: "SP Item details",
            btns: [
                {
                    access: "57",
                    name: "Edit item",
                    link: "/sp-items/edit/"
                }
            ]
        },
        "/sp-items/edit/:Id": {
            title: "Edit SP Item",
            subtitle: "Edit SP Item details",
            btns: [
                {
                    access: "55",
                    name: "Back to View",
                    link: "/sp-items/view/"
                }
            ]
        },
        "/sp-items/create": {
            title: "Create SP Item",
            subtitle: "Create new SP Resolution/Ordinance/Item",
            btns: [
                {
                    access: "55",
                    name: "Back to List",
                    link: "/sp-items"
                }
            ]
        }
    };
    return routes[key];
}